import React from 'react';
import { CheckIcon } from 'lucide-react';
import { PACKS, WHATSAPP_URL } from '../data/content';
import { Overline } from './Overline';
export function UpsellSection() {
  return <section className="bg-cream py-24 lg:py-32" data-id="element-386" data-mp="1wmgau9ks78rg">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-387" data-mp="1wkvj0rpuq3xa">
        <div className="max-w-3xl" data-id="element-388" data-mp="1rnvckfp3az5n">
          <Overline data-id="element-389" data-mp="1rmu1ib82qcnx">Packs</Overline>
          <h2 className="mt-6 font-serif text-[2.1rem] font-light leading-[1.1] text-ink sm:text-[2.8rem]" data-id="element-390" data-mp="1rlium2jc0osl">
            Si vas a cambiar el suelo, este es el mejor momento para dejar tu vivienda realmente
            terminada
          </h2>
          <p className="mt-6 text-[15px] leading-relaxed text-stone-600" data-id="element-391" data-mp="1dolwdg0vw51o">
            El suelo nuevo transforma la casa. Pero cuando lo combinas con rodapiés, puertas y
            pintura, el cambio parece una reforma completa.
          </p>
        </div>

        <div className="mt-16 grid gap-6 lg:grid-cols-3 lg:gap-8" data-id="element-392" data-mp="37z90neu0hn4v">
          {PACKS.map(pack => <article key={pack.name} className={`flex h-full flex-col rounded-3xl p-8 transition-[transform,box-shadow] duration-300 ease-premium hover:-translate-y-1 lg:p-10 ${pack.featured ? 'bg-charcoal text-cream shadow-lift' : 'border border-ink/10 bg-white text-ink shadow-card hover:shadow-lift'}`} data-id="element-393" data-mp="1qmlx0yjew9gz">
              {pack.featured && <span className="mb-5 w-fit rounded-full border border-champagne/60 px-3 py-1 text-[10.5px] uppercase tracking-overline text-champagne" data-id="element-394" data-mp="2abwbk97f8odi">
                  El más elegido
                </span>}
              <h3 className={`font-serif text-2xl font-light leading-snug ${pack.featured ? '' : 'text-ink'}`} data-id="element-395" data-mp="20ipb92rjfyka">
                {pack.name}
              </h3>
              <p className={`mt-4 text-[13.5px] leading-relaxed ${pack.featured ? 'text-cream/70' : 'text-stone-600'}`} data-id="element-396" data-mp="2y07a35pnabym">
                {pack.text}
              </p>
              <ul className={`mt-7 space-y-3 border-t pt-6 ${pack.featured ? 'border-cream/15' : 'border-ink/10'}`} data-id="element-397" data-mp="32y4jl4yecewq">
                {pack.includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-398" data-mp="2synaedjxriw0">
                    <CheckIcon className={`mt-0.5 h-3.5 w-3.5 shrink-0 ${pack.featured ? 'text-champagne' : 'text-walnut'}`} aria-hidden="true" data-id="element-399" data-mp="2oy3hjm6eb1fo" />
                    <span className={`text-[13px] ${pack.featured ? 'text-cream/85' : 'text-ink/80'}`} data-id="element-400" data-mp="2a8fcqaz09kn7">
                      {item}
                    </span>
                  </li>)}
              </ul>
              <div className="mt-auto pt-8" data-id="element-401" data-mp="218ix0yulfw4a">
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className={`inline-flex w-full items-center justify-center rounded-full px-6 py-3.5 text-[12.5px] font-medium tracking-wide transition-[background-color,color,border-color] duration-200 ease-premium ${pack.featured ? 'bg-cream text-ink hover:bg-champagne' : 'border border-ink/20 text-ink hover:border-ink hover:bg-ink hover:text-cream'}`} data-id="element-402" data-mp="gpykd8ouhgs5">
                  Consultar este pack
                </a>
              </div>
            </article>)}
        </div>

        <p className="mx-auto mt-20 max-w-3xl border-t border-ink/10 pt-12 text-center font-serif text-[1.6rem] font-light leading-snug text-ink sm:text-[2rem]" data-id="element-403" data-mp="bqvk01jt7yqi">
          A veces no necesitas una reforma integral. Necesitas cambiar los elementos que más
          envejecen tu casa.
        </p>
      </div>
    </section>;
}